import React from 'react';
import { motion } from 'framer-motion';
import { ComicText } from './ui/comic-text';

const EndingSection: React.FC = () => {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{ backgroundColor: '#2C2721' }}
    >

      {/* 主要内容 */}
      <motion.div 
        className="relative z-10 text-center px-6 max-w-4xl mx-auto"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.5 }}
      >
        <motion.h1 
          className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl leading-relaxed font-black"
          style={{ 
            fontFamily: "'Cardival-Demo', sans-serif",
            color: '#F1EFE0',
            fontWeight: '900'
          }}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <span className="block mb-4">" This is just one chapter.</span>
          <motion.span 
            className="block"
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
          >
            The rest of the story,
          </motion.span>
          <motion.span 
            className="block mt-4 flex items-center justify-center flex-wrap gap-2"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            viewport={{ once: true }}
          >
            <span>I'm still</span>
            <ComicText 
              fontSize={5}
              style={{ 
                display: 'inline-block',
                transform: 'skewX(-10deg) rotate(-3deg)',
                margin: '0 10px'
              }}
            >
              coding
            </ComicText>
            <span>. "</span>
          </motion.span>
        </motion.h1>

        {/* 装饰性代码符号 */}
        <motion.div 
          className="mt-12 flex justify-center items-center gap-4"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.8 }}
          viewport={{ once: true }}
        >
          <span className="text-4xl text-gray-500 opacity-60">&lt;</span>
          <motion.span 
            className="text-2xl text-[#F1EFE0] opacity-40"
            animate={{ opacity: [0.4, 0.8, 0.4] }}
            transition={{ duration: 2, repeat: Infinity }}
          >
            /&gt;
          </motion.span>
          <span className="text-4xl text-gray-500 opacity-60">_</span>
        </motion.div>
      </motion.div>

      {/* 底部渐变 */}
      <div 
        className="absolute bottom-0 left-0 right-0 h-32"
        style={{
          background: 'linear-gradient(to top, rgba(44, 39, 33, 0.8), transparent)'
        }}
      />
    </section>
  );
};

export default EndingSection;